import { featureFlags, FeatureFlagName } from "src/lib/featureFlags";

export type StreakMode = "daily" | "weekly";

/**
 * Returns the current weigh-in streak calculation mode.
 * Controlled by the 'showDailyWeightReadings' debug feature flag.
 * 'daily'  → counts weight logs per day within the current week (0–7)
 * 'weekly' → counts consecutive weeks with ≥1 weight log (default)
 */
export const getStreakMode = (): StreakMode =>
  featureFlags.getFlag(FeatureFlagName.showDailyWeightReadings)
    ? "daily"
    : "weekly";

/** Number of weeks in the ramp-up phase before showing just the count (0/4 → 4/4 → 5, 6, 7…) */
export const WEEKLY_STREAK_RAMP = 4;
